import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

var Reseller = React.createClass({

  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },


  render() {
      const { t } = this.props;
    var store = this.state.store;
      var resellers = store.get('reseller').toJS();
    return (
      <div className="text-center">
        <h1>{t('common:resellers_available')}</h1>
       
       	<div className="row row-centered">
		{Object.keys(resellers).map(function(key){
			var reseller = resellers[key];
			return (
				<div className="col-sm-4 col-centered text-center" key={key}>
					<a href={reseller.url} title={reseller.name} target="_blank">
						<img src={"https://www.sonic.com"+store.getIn(['resellerLogos', reseller.username])} alt={reseller.name} />
					</a>
				</div>
			);
		})}
    	</div>
      </div>
    );
  }
});

export default  translate('common', { wait: true })(Reseller);